import { useCan } from "../../utils/permissions.js";
import Archive from "../Archive/Archive.jsx";
import ChatBtn from "../ChatBtn/ChatBtn.jsx";
import LogOut from "../LogOut/LogOut.jsx";
import NewServiceBookingBtn from "../NewServiceBookingBtn/NewServiceBookingBtn.jsx";
import Notifications from "../Notifications/Notifications.jsx";
import SearchBar from "../SearchBar/SearchBar.jsx";
import Support from "../Support/Support.jsx";
import ThemeSwitcher from "../ThemeSwitcher/ThemeSwitcher.jsx";
import css from "./ControlBar.module.css";

export default function ControlBar() {
  const can = useCan();

  return (
    <div className={css.wrapper}>
      <NewServiceBookingBtn />
      {can("archive", "read") && <Archive />}
      {/* <SearchBar /> */}
      {/* <ThemeSwitcher /> */}
      {/* <Support /> */}
      <Notifications />
      {/* <ChatBtn /> */}
      <LogOut />
    </div>
  );
}
